import { Box, Button, Card, Flex, Heading, Tag, Text } from '@chakra-ui/react';
import { useState } from 'react';

import type { WalkInCustomerType } from '../types';
import ConfirmStartExecutionDialog from './ConfirmStartExecutionDialog';

type Props = {
  customer: WalkInCustomerType,
};

const NewExecutionCard = ({ customer }: Props) => {
  const [showConfirmStartExecutionDialog, setShowConfirmStartExecutionDialog] = useState(false);

  return (
    <Box position="relative">
      <Card.Root
        size="sm"
        variant="subtle"
        bg="grayscale.fg"
        mt={4}
        p={2}
        display="flex"
        justifyContent="center"
        _hover={{ bg: 'bg.muted' }}
        borderLeft="solid 6px"
        borderColor="bg.muted"
      >
        <Flex gap={2} alignItems="center" justifyContent="space-between">
          <Box>
            <Flex
              gap={{ base: 1, md: 2 }}
              flexDirection={{ base: 'column', lg: 'row' }}
              mb={{ base: 1, md: 0 }}
            >
              <Heading
                size="sm"
                color="fg.default"
              >
                {customer.name}
              </Heading>
              <Flex gap={1} flexWrap="wrap">
                {customer.tags.map((tag) => (
                  <Tag.Root key={tag} size="md" bg="argos.fg" color="grayscale" fontWeight={600}>
                    <Tag.Label>{tag}</Tag.Label>
                  </Tag.Root>
                ))}
              </Flex>
            </Flex>
            <Text color="fg.muted" fontSize="xs">
              {customer.portfolio.name}
            </Text>
          </Box>

          <Button bg="green.700" color="white" onClick={() => setShowConfirmStartExecutionDialog(true)}>
            Iniciar
          </Button>
        </Flex>
      </Card.Root>

      {showConfirmStartExecutionDialog && (
        <ConfirmStartExecutionDialog
          handleClose={() => setShowConfirmStartExecutionDialog(false)}
          customerId={customer.id}
        />
      )}
    </Box>
  );
};

export default NewExecutionCard;
